import React, {useMemo} from "react";
import {T} from "@tolgee/react";
import FlexBox from "view/components/Layout/FlexBox";
import {Button, Typography} from "@material-ui/core";
import {useFormStateContext} from "view/SignUp/SignUpToken/context";
import ResendButton from "view/SignUp/SignUpToken/components/ResendButton";
import {FFairPrimaryBlackTypeLogo} from "view/images/FFairLogo";
import {useParams} from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import {composeQuickOrderURL} from "tools/routing";
import useStyles from "./styles";

type QuickOrderTokenPayload = {
  showId?: string;
  exhibitorPairId?: string;
  quickOrderId?: string;
};

const SuccessPage = () => {
  const classes = useStyles();
  const {
    credentials: {email},
  } = useFormStateContext();
  const {uid: token} = useParams();

  const quickOrderLink = useMemo(() => {
    if (!token) return undefined;
    try {
      const decoded = jwtDecode<QuickOrderTokenPayload>(token);
      if (decoded.showId && decoded.exhibitorPairId && decoded.quickOrderId) {
        return composeQuickOrderURL({
          showId: decoded.showId,
          exhibitorPairId: decoded.exhibitorPairId,
          orderId: decoded.quickOrderId,
        });
      }
    } catch {
      console.warn("Invalid token: ", token);
    }
    return undefined;
  }, [token]);

  return (
    <FlexBox column className={classes.wrapper}>
      <Typography className={classes.mainText}>
        <T keyName="global.sign_up.success.thank_you" />
      </Typography>
      <Typography className={classes.mainText}>
        <T keyName="global.sign_up.success.check_email" params={{email}} />
      </Typography>
      <ResendButton />
      {quickOrderLink && (
        <Button
          color="primary"
          variant="contained"
          href={quickOrderLink}
          style={{marginTop: 16}}
        >
          <T keyName="global.sign_up.success.go_to_quick_order" />
        </Button>
      )}
      <FlexBox alignCenter justifyCenter className={classes.poweredByRow}>
        <Typography className={classes.poweredByText}>Powered by</Typography>
        <FFairPrimaryBlackTypeLogo width={82} height={40} />
      </FlexBox>
    </FlexBox>
  );
};

export default SuccessPage;
